import styled from "styled-components";

// Square tech tag. Replaces every pill in the pre-rebuild codebase.
// 1px hard border, zero radius, Helvetica caps — DESIGN.md:480-487.

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.ui};
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 6px 9px;
  border-radius: 0;
  border: 1px solid
    ${({ $tone, theme }) =>
      $tone === "experience" || $tone === "connect"
        ? "rgba(0,0,0,0.28)"
        : "rgba(255,255,255,0.2)"};
  color: ${({ $tone, theme }) =>
    (theme.biome[$tone] || theme.biome.about).ink};
  background: transparent;
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export default Chip;
